var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveFav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "active_fav") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_line_style_24px",
    transform: "translate(-1431 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3697",
    "data-name": "Rectangle 3697",
    width: 24,
    height: 24,
    transform: "translate(1431 13)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "star_FILL1_wght400_GRAD0_opsz20",
    d: "M5.062,18l1.313-5.542L2,8.729l5.75-.5L10,3l2.25,5.25L18,8.729l-4.375,3.729L14.938,18,10,15.062Z",
    transform: "translate(1433 15)",
    fill: "#08232f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFav);
export default __webpack_public_path__ + "static/media/active_fav.749e55b101e666ede49c2670d9b2d8ad.svg";
export { ForwardRef as ReactComponent };